export enum MaterialDisposition {
  SCRAPPED_IN_COUNTRY = 'Scrapped in Country',
  RELABELED_AND_USED_IN_COUNTRY = 'Relabeled and used in country',
}
